interface SliderProps {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  className?: string;
}

export function Slider({ value, min, max, step, onChange, className = '' }: SliderProps) {
  const pct = ((value - min) / (max - min)) * 100;

  return (
    <input
      type="range"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={e => onChange(parseFloat(e.target.value))}
      className={`w-full h-1.5 rounded-full appearance-none cursor-pointer accent-chart-teal ${className}`}
      style={{
        background: `linear-gradient(to right, #14B8A6 0%, #14B8A6 ${pct}%, var(--color-slider-track) ${pct}%, var(--color-slider-track) 100%)`,
      }}
    />
  );
}
